import React from 'react';
import { isEmpty } from 'lodash';
import { Title } from 'Components/frameworks/title/Title';
import type { ProductFeatureDetailFacilityProps } from './ProductFeatureDetailFacility';
import { ProductFeatureDetailFacility } from './ProductFeatureDetailFacility';
type Props = {
  className?: string;
  items: Array<ProductFeatureDetailFacilityProps>;
  title?: string;
};
export const ProductFeatureDetailFacilities = ({ className, items = [], title = '' }: Props) => {
  if (!items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title hLevel={4} theme="title-brand-n4">
        {title}
      </Title>
      <ul className="my-10 list-none p-0 sm:columns-2">
        {items.map((item, idx) => {
          return (
            !isEmpty(item) && (
              <li
                className={`break-inside-avoid-column my-10${idx === 0 ? 'mt-0' : ''}`}
                key={item.id}
              >
                <ProductFeatureDetailFacility {...item} />
              </li>
            )
          );
        })}
      </ul>
    </section>
  );
};
